import api from './client';

export interface Invitation {
  id: string;
  email: string;
  role: string;
  expires_at: string;
  created_at: string;
  invited_by_name?: string;
}

export interface SeatUsage {
  plan: string;
  member_count: number;
  pending_count: number;
  occupied: number;
  included_seats: number;
  member_max_total: number | null;
  addon_price_cents: number | null;
  additional_seats_used: number;
  available_seats: number;
  monthly_base_cents: number;
  monthly_total_cents: number;
}

export interface InvitationDetails {
  id: string;
  email: string;
  role: string;
  expires_at: string;
  organization_name: string;
}

export const getUserQuota = async (): Promise<SeatUsage> => {
  const response = await api.get('/api/invitations/quota');
  return response.data;
};

export const listInvitations = async (): Promise<Invitation[]> => {
  const response = await api.get('/api/invitations');
  return response.data.invitations || [];
};

export const createInvitation = async (data: {
  email: string;
  role: string;
  confirm_addon?: boolean;
}): Promise<{ message: string; invitation: Invitation; seat_type: string }> => {
  const response = await api.post('/api/invitations', data);
  return response.data;
};

export const cancelInvitation = async (id: string): Promise<void> => {
  await api.delete(`/api/invitations/${id}`);
};

export const resendInvitation = async (id: string): Promise<void> => {
  await api.post(`/api/invitations/${id}/resend`);
};

export const getInvitationByToken = async (token: string): Promise<InvitationDetails> => {
  const response = await api.get(`/api/invitations/accept/${token}`);
  return response.data.invitation;
};

export const acceptInvitation = async (
  token: string,
  data: { full_name: string; password: string }
): Promise<{ message: string; user: { id: string; email: string } }> => {
  const response = await api.post(`/api/invitations/accept/${token}`, data);
  return response.data;
};
